module.exports = __webpack_public_path__ + "media/images/banner-institucional-1431ee5813d55b0f94ccefbd0dd3b0fa.jpg";